import { AuthPage } from "./AuthPage";

const AuthPageWrapper = () => {
    return (
        <AuthPage />
    )
}

export default AuthPageWrapper;